import {buildRequest, buildUrl, getCurrentApiEndpoint} from "./apiCall";
import {settingsInitialState} from "../../store/settings/reducer";
import {IApplicationState} from "../../store";
import {LogLevel} from "../../store/log/types";
import {IHandshake} from "../../store/common/types";

export default function getGlobalErrorHandler(category: string, handshake: IHandshake, state: Partial<IApplicationState>) {
    return function (event: Event | string, source?: string, rowNumber?: number, columnNumber?: number, error?: Error, data?: Record<string, any>): void {
        if (window.DISABLE_ERROR_LOGGING)
            return;

        (async () => {
            const {
                api: {
                    endpoints: apiEndpoints,
                    uriTemplate: apiUriTemplate
                }
            } = state.settings || settingsInitialState;

            try {
                const url = buildUrl(getCurrentApiEndpoint(apiEndpoints), apiUriTemplate, {
                    section: "log",
                    method: "post",
                });

                const errorLog = error
                    && Object.getOwnPropertyNames(error).reduce((acc, key) => ({
                        ...acc,
                        [key]: (error as any)[key]
                    }), {}) as Record<string, any>;

                const request = buildRequest(handshake.signature, {
                    appVersion: handshake.version,
                    messages: [{
                        logLevel: LogLevel.Fatal,
                        category: category,
                        message: event,
                        stack: errorLog && errorLog.stack,
                        data: {
                            clientTime: new Date().toISOString(),
                            error: errorLog,
                            source,
                            rowNumber,
                            columnNumber,
                            ...data
                        },
                    }]
                });

                await fetch(url, request);
            }
            catch (error) {
                console.error(error);
            }
        })();
    };
}